<template>
  <div
    class="box-border !cursor-pointer h-full rounded-3xl bg-white p-3 md:p-5"
  >
    <div class="flex h-full flex-col items-center animate-pulse">
      <div class="bg-gray-300 w-[104px] md:w-[140px] h-[104px] md:h-[140px] rounded-full"></div>

      <div class="mt-[12px] flex w-full grow flex-col justify-between text-center md:mt-5">
        <div>
          <div class="bg-gray-300 h-6 md:h-8 w-3/4 mx-auto rounded mb-1 md:mb-2"></div>
          <div class="bg-gray-300 h-4 md:h-6 w-1/2 mx-auto rounded mb-2 md:mb-4"></div>
          <div class="bg-gray-300 h-4 md:h-6 w-1/3 mx-auto rounded mb-2 md:mb-4"></div>
        </div>
        <div class="bg-gray-300 h-12 md:h-14 w-full rounded mt-3 md:mt-4"></div>
      </div>
    </div>
  </div>
</template>
